import { useQuery } from '@tanstack/react-query';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import { getUserInfo } from 'api/requests/core/users';
import { useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import XConnectPreloader from 'shared/components/XConnectPreloader';
import GtmHoc from 'shared/gtm/hoc';
import { queryKeyBuilder } from 'shared/query';
import { redirectCognito, redirectLogout } from 'shared/utils/auth';

function App() {
  const [searchParams] = useSearchParams();

  const { flagsReady } = useFlagsStatus();
  const isLoginFailure = searchParams.get('errorCode') || searchParams.get('errorDescription');
  const { isError: isUserErrored, isPending: isUserLoading } = useQuery({
    queryKey: queryKeyBuilder.currentUser(),
    queryFn: getUserInfo,
  });

  useEffect(() => {
    if (isLoginFailure) {
      redirectCognito();
    } else if (isUserErrored) {
      redirectLogout();
    }
  }, [isLoginFailure, isUserErrored]);

  return !flagsReady || isUserLoading ? (
    <XConnectPreloader />
  ) : (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}

export default GtmHoc(App);
